
import {Component, Prop, Vue} from "vue-property-decorator";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import SalonGeneralForm from "@/form/salonGeneral/salonGeneral";
import moment from 'moment';
//import {VNode} from "vue";
@Component({
  components: {FormGroup},
  methods: {moment}
})
export default class SalonGeneralFormComponent extends Vue {
  @Prop() readonly form!: SalonGeneralForm;
  filterOption(input: string/*, option: VNode*/): void {
    this.$emit('search', input);
  }
  changeCity(val: any): void {
    console.log(val);
  }
  created(): void {
  }
  handleOpeningDateChange(value: any): void {
    this.form.opening_date = value.format('DD.MM.YYYY');
  }
  handleCCDateChange(value: any): void {
    this.form.conclusion_contract_date = value.format('DD.MM.YYYY');
  }
}
